import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CustomP } from './../CustomMalt/Typography';
import api from './../../utils/api';

import MessageWithLink from './../MessageWithLink/MessageWithLink';

import styles from './ResendCountdown.css';
import messages from './messages';

class ResendCountdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      time: props.initialTime,
      intervalId: null,
    };

    this.startCountdown = this.startCountdown.bind(this);
    this.resend = this.resend.bind(this);
    this.rewind = this.rewind.bind(this);
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    this.stopCountdown();
  }

  startCountdown() {
    let intervalId = setInterval(() => {
      if (this.state.time <= 0) {
        this.stopCountdown();
        return;
      }
      this.setState({
        time: this.state.time - 1,
      });
    }, 1000);

    this.setState({ intervalId });
  }

  stopCountdown() {
    clearInterval(this.state.intervalId);
  }

  rewind() {
    this.setState({ time: this.props.initialTime });
    this.startCountdown();
  }

  resend(event) {
    event.preventDefault();
    const { resendEndpoint, resendPayload, onSuccess, onError } = this.props;

    api
      .post(resendEndpoint, resendPayload)
      .then(res => {
        onSuccess(res);
        this.rewind();
      })
      .catch(err => {
        onError(err);
        this.rewind();
      });

    if (typeof this.props.track === 'function') this.props.track();
  }

  render() {
    const { time } = this.state;
    const { center, isLink } = this.props;

    return (
      <div
        className={classnames(
          { [styles.center]: center },
          styles.resendContainer
        )}
      >
        {time === 0 ? (
          <CustomP className={styles.label}>
            <MessageWithLink
              message={messages[isLink ? 'resendLinkSend' : 'resendCodeSend']}
              linkMessage={
                messages[isLink ? 'resendLinkSendLink' : 'resendCodeSendLink']
              }
              onClick={this.resend}
            />
          </CustomP>
        ) : (
          <CustomP className={classnames(styles.label, styles.waitInGrey)}>
            <FormattedMessage
              {...messages[isLink ? 'resendLinkWait' : 'resendCodeWait']}
              values={{ countdown: time }}
            />
          </CustomP>
        )}
      </div>
    );
  }
}

ResendCountdown.defaultProps = {
  initialTime: 60,
  onError: () => {},
};

ResendCountdown.propTypes = {
  resendEndpoint: PropTypes.string.isRequired,
  resendPayload: PropTypes.object,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  initialTime: PropTypes.number,
  track: PropTypes.func,
  center: PropTypes.bool,
  isLink: PropTypes.bool,
};

export default ResendCountdown;
